export default "__VITE_ASSET__QrnCqwns__"